module.exports = __webpack_public_path__ + "img/emerald_ds_extended.43f1e2b2.svg";